import get from 'lodash/get';
import API from '@/api';

const types = {
  SET_TAX_YEARS: 'SET_TAX_YEARS',
};

const state = {
  taxYears: [],
};

const getters = {};

const mutations = {
  [types.SET_TAX_YEARS](state, years) {
    state.taxYears = years;
  },
};

const actions = {
  async setTaxYearsOptions({ commit }, years) {
    commit(types.SET_TAX_YEARS, years);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
